import { ServiceOrder } from './service-orders-by-claim-number-response.model';
import { SpecialistVendor } from './specialist-vendor.model';

export class SparePartsResponse {
  public hasToShow: boolean;
  public serviceOrders: Array<ServiceOrder>;
  public specialistVendors: Array<SpecialistVendor>;
}
